// @flow
import { _get, _post } from "./methods";

export default {
  listPreviews: (params: any) => _get("/admin/exhibitions/previews", params),
  tate: {
    listMappings: (params: any) => _get("/admin/exhibitions/tate/mappings", params),
    saveMapping: (params: any) => _post("/admin/exhibitions/tate/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/exhibitions/tate/import_snapshot", params)
  },
  national_gallery: {
    listMappings: (params: any) =>
      _get("/admin/exhibitions/national_gallery/mappings", params),
    saveMapping: (params: any) =>
      _post("/admin/exhibitions/national_gallery/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/exhibitions/national_gallery/import_snapshot", params)
  },
  photographers_gallery: {
    listMappings: (params: any) =>
      _get("/admin/exhibitions/photographers_gallery/mappings", params),
    saveMapping: (params: any) =>
      _post("/admin/exhibitions/photographers_gallery/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/exhibitions/photographers_gallery/import_snapshot", params)
  },
  barbican: {
    listMappings: (params: any) =>
      _get("/admin/exhibitions/barbican/mappings", params),
    saveMapping: (params: any) =>
      _post("/admin/exhibitions/barbican/mappings", params),
    importSnapshot: (params: any) =>
      _post("/admin/exhibitions/barbican/import_snapshot", params)
  }
};
